module.exports = __webpack_public_path__ + "img/swiper-5.0b78483.png";